import type { FaireProductEntity } from "../../entity_types/product";

export const p_hbvhtvmdjd: FaireProductEntity = {
  token: "p_hbvhtvmdjd",
  type: "product",
  name: "Grateful 3D Embroidery - Light Weight Stitch Sweatshirt",
  brandToken: "b_521sy8ez50",
  brandName: "Jadelynn Brooke",
  imageUrl:
    "https://cdn.faire.com/fastly/db3b7aa106d90b78938153539eb8377a1ce0ae39b2c07c97b16e2196784a5bcc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07ba13d05be909b6d16ae37331c7a9e316676ea4c737850d0121647cd69f523c.jpeg",
    "https://cdn.faire.com/fastly/0a99277595bf25363867dc6918d29ecb873d11c97a2f5a216421eeadcc56b8b5.jpeg",
    "https://cdn.faire.com/fastly/524a5a647c8d566a88f181d4c556a262983746de753f1de0aa161a80a896ba0e.jpeg",
    "https://cdn.faire.com/fastly/e336e6b34c3b7f432186d2ef4ab0480fb43efd6e240c6024f8bc61943c30e851.jpeg",
    "https://cdn.faire.com/fastly/3e5505545745584d3c5aa2da360ce5639cba9b17b5906f5f50ea581a8d4cec03.jpeg",
  ],
  priceDollars: 19.29,
  description:
    "60% Cotton; 40% Polyester\n\n3D Embroidered Lettering On the Front\nCrew Neck\nHand Embroidered Accent Stitching Along The Side Of The Wearer's Right Neckline\nSide Slits\n—-------------------------------------------\nJadelynn Brooke, women-owned brand, sister-founded, Austin Texas brand, lifestyle brand, women's apparel wholesale, wholesale graphic tees, wholesale boutique bags, wholesale accessories, wholesale gifts, boutique clothing wholesale, boutique wholesale, resale clothing, retail ready, high margin boutique, fast moving inventory, low minimum order, trendy women's fashion, boho chic, southern style, graphic tee aesthetic, positive vibes apparel, fun gifts for women, bestselling boutique items, gift shop bestsellers, impulse buy gifts, Instagram-worthy products, customer favorite, gifts for her, bachelorette gifts, birthday gifts wholesale, holiday gift shop, game day apparel, giftable, boutique find, trending, bestseller, best-seller, newarrivals, everyday style, womens wear, statement piece, unique find, must have\n\nLIMITED QUANTITIES REMAINING, NO RESTOCK",
  tags: [],
  msrpDollars: 41.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:43.576Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
